export default __webpack_public_path__ + "5cc0d0645a780d31d16cdd94185a8085.jpeg";